<template>
    <div>
        <v-server-table name="subcontractorTable" ref="subcontractorTable" url="/subcontractors/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <button type="button" class="btn btn-outline-success" v-on:click="exportSubcontractors()"><i class="fa fa-file-excel-o"></i> Export</button>
                <router-link to="subcontractors/statuses" class="btn btn-warning" target="_blank">
                    Status Help
                </router-link>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <router-link slot="subcontractor_name" slot-scope="props" :to="`/subcontractors/view/${props.row.subcontractor_id}`" title="View Subcontractor">
                {{ props.row.subcontractor_name }}
            </router-link>

            <template slot="status_name" slot-scope="props">
                <template v-if="props.row.status_name">
                    <span :title="getStatusTitle(props.row.status_name)" :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</span>
                </template>
            </template>

            <template slot="has_previous_projects" slot-scope="props">
                {{ props.row.has_previous_projects === null ? '' : (props.row.has_previous_projects ? 'Yes' : 'No') }}
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment("MM/DD/YYYY") }}
            </template>

            <template slot="updated_at" slot-scope="props">
                {{ props.row.updated_at | moment("MM/DD/YYYY") }}
            </template>

            <template slot="valid_until" slot-scope="props">
                <template v-if="props.row.valid_until">{{ props.row.valid_until | moment("MM/DD/YYYY") }}</template>
            </template>

            <template slot="average_rating" slot-scope="props">
                {{ props.row.average_rating ? (+props.row.average_rating).toFixed(1) : '-' }}
            </template>
        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['assetType'],

        data: function() {
            return {
                has_loaded: false,
                options: {
                    headings: {
                        subcontractor_name: 'Name',
                        status_name: 'Status',
                        trades: 'Trade',
                        city: 'City',
                        state: 'State',
                        created_at: 'Created At',
                        updated_at: 'Last Updated',
                        website: 'Website',
                        company_contact_email: 'Contact Email',
                        designations: 'Designations',
                        areas: 'Working Areas',
                        company_id_num: 'Federal ID/SSN',
                        has_previous_projects: 'Performed Past Work',
                        created_at: 'Created At',
                        updated_at: 'Last Updated',
                        valid_until: 'Approved Until',
                        average_rating: 'Overall Rating',
                        days_remaining: 'Days Remaining',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'subcontractors.subcontractor_name',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('subcontractorCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //INclude the asset
                        data.assetType = this.assetType;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'subcontractor_id',
                    saveState: true,
                    storage: 'local',
                },
            }
        },

        computed: {
            columns() {
                let columns = ['subcontractor_name', 'status_name', 'trades', 'city', 'state', 'website', 'company_contact_email', 'designations', 'areas', 'company_id_num', 'has_previous_projects', 'created_at', 'updated_at', 'valid_until', 'average_rating'];

                if (this.assetType == 'Expiring')
                {
                    columns.push('days_remaining');
                }

                return columns;
            },
        },

        methods: {
            getStatusTitle(status_name) {
                if (status_name == 'In Progress')
                {
                    return 'Subcontractor is in process of completing the prequalification form.';
                }
                else if (status_name == 'Renewal In Progress')
                {
                    return 'Previously approved subcontractor is in the process of submitting current information.';
                }
                else if (status_name == 'In Review')
                {
                    return 'Subcontractor has submitted prequalification information for review.';
                }
                else if (status_name == 'Renewal In Review')
                {
                    return 'Previously approved subcontractor has submitted current information for review.';
                }
                else if (status_name == 'Approved')
                {
                    return 'Prequalification information has been reviewed and subcontractor is approved to use.';
                }
                else if (status_name == 'Not Approved')
                {
                    return 'Prequalification information has been reviewed and subcontractor is NOT approved to use. Refer to comments in the subcontractor record.';
                }
                else if (status_name == 'Conditionally Approved')
                {
                    return 'Prequalification information has been reviewed and subcontractor is conditionally approved to use per the conditions listed in comments in the subcontractor record.';
                }
                else if (status_name == 'Incomplete')
                {
                    return 'Prequalification information has been in progress or in review for more than a month.  Review can not be completed until prequalification information is submitted. Check all comments areas of the subcontractor record for details.';
                }
                else if (status_name == 'Renewal Incomplete')
                {
                    return '(1) Previously approved subcontractor has not submitted current information within 30 days of expiration of their approved status - OR - (2) Current prequalification from a previously approved subcontractor has been in progress or in review for more than a month. Renewal of approved status can not be completed until current information is submitted. Check all comments areas of the subcontractor record for details.';
                }
            },

            exportSubcontractors(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: this.$store.state.tableFilters.subcontractorFilters,
                    query: (this.$refs.subcontractorTable.getRequestParams()).query,
                    orderBy: this.$refs.subcontractorTable.options.orderBy.column,
                    ascending: this.$refs.subcontractorTable.options.orderBy.ascending,
                    table: 'subcontractor-table',
                    columns: this.$refs.subcontractorTable.columns,
                };

                //Send it
                this.$http.post('/subcontractors/export', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {})
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            // Ghetto column remembering, because for some reason vue-tables-2 will store this, but not set it when the table loads, and there's also no way to pass ALL of the columns, so we'll toggle them off one by one
            // But wait, there's more! Since this fires every table load, we toggle them BACK ON when a load event happens, but there isn't a hideColumn() function...
            // So, we'll just... only do this the first time... If they click a column it'll still respond, if they do some other load event, we don't want the columns to change...
            // I'm not happy this feature is missing, here's a feature request from 2019-04-08 https://github.com/matfish2/vue-tables-2/issues/688
            // hideColumns: function(event){
            //     if (this.has_loaded)
            //     {
            //         return;
            //     }

            //     let visible_columns = JSON.parse(localStorage['vuetables_subcontractorTable']).userColumnsDisplay;

            //     //Make sure we actually have some visible columns
            //     if(!visible_columns)
            //     {
            //         return;
            //     }

            //     //Loop
            //     for (let i = 0; i < this.columns.length; i++)
            //     {
            //         if (visible_columns.indexOf(this.columns[i]) === -1)
            //         {
            //             this.$refs.subcontractorTable.toggleColumn(this.columns[i]);
            //         }
            //     }

            //     this.has_loaded = true;
            // },

            filtersChanged: function(filters) {
                //Set the store
                this.$store.commit('setFilters', {
                    key: 'subcontractorFilters',
                    filters: filters
                });

                //Set the data
                this.$refs.subcontractorTable.getData();
            },

            filtersCleared() {
                //Update the Store
                this.$store.commit('setFilters', {
                    key: 'subcontractorFilters',
                    filters: {
                        'subcontractors.status_id': [],
                        'subcontractors.valid_until' : null,
                    }
                });

                ///Clear the Saved
                this.$store.commit('setAppliedFilter', null);

                //Refresh
                this.$refs.subcontractorTable.refresh();
            },

            extractFilters: function() {
                let filters = {
                    'subcontractors.status_id': [],
                    'subcontractors.valid_until': null,
                };

                let table_filters = this.$store.state.tableFilters.subcontractorFilters

                for (var i = 1; i <= table_filters['subcontractors.status_id'].length; i++) {
                    //Add each id
                    filters['subcontractors.status_id'].push(table_filters['subcontractors.status_id'][(i - 1)]['id']);
                }

                filters['subcontractors.valid_until'] = table_filters['subcontractors.valid_until'];
            },
        },
    }
</script>
